export const SearchTypeUser = 29 as const;
export type TSearchTypeUser = typeof SearchTypeUser;

/** elementSubType1 */
export enum UserType {
	IMPORTED_BY = 0,
	MODIFIED_BY = 1,
}
